import { render, staticRenderFns } from "./StandardBorderedButton.vue?vue&type=template&id=7d16c4a8&scoped=true"
import script from "./StandardBorderedButton.vue?vue&type=script&lang=js"
export * from "./StandardBorderedButton.vue?vue&type=script&lang=js"
import style0 from "./StandardBorderedButton.vue?vue&type=style&index=0&id=7d16c4a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d16c4a8",
  null
  
)

export default component.exports